import { render, staticRenderFns } from "./CatalogoAccionesActividades.vue?vue&type=template&id=10b86ddc"
import script from "./CatalogoAccionesActividades.vue?vue&type=script&lang=js"
export * from "./CatalogoAccionesActividades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports